import React, { ReactNode } from "react";
import styled from "styled-components";
import { Footer } from "../Footer";
import { primaryGradient } from "../GradientBox";
import { SlantedSection } from "./SlantedSection";
import { SizedBox } from "../SizedBox";
import { FooterBackground } from "./FooterBackground";
import { AndroidStoreButton, AppStoreButton } from "../StoreButtonsBlock";

export const LandingPageTemplate: React.FC<{
  header: ReactNode;
  illustration: ReactNode;
  androidStoreListing: string;
  appStorePpid: string;
}> = (props) => {
  return (
    <Page>
      <SizedBox height={8} />
      <SlantedSection
        offset={-470}
        height={116}
        width={1000}
        justifyContent="right"
        alignItems="center"
      >
        <TopContent header={props.header} />
      </SlantedSection>
      <SizedBox height={8} />
      <IllustrationWrapper>{props.illustration}</IllustrationWrapper>
      <SlantedSection
        offset={300}
        height={150}
        width={1000}
        justifyContent="left"
        alignItems="center"
      >
        <BottomContent
          androidStoreListing={props.androidStoreListing}
          appStorePpid={props.appStorePpid}
        />
      </SlantedSection>
      <FooterBackground>
        <Footer />
      </FooterBackground>
    </Page>
  );
};

export default LandingPageTemplate;

const Page = styled.div`
  display: flex;
  flex-direction: column;
  background: ${primaryGradient};
`;

const TopContent: React.FC<{
  header: ReactNode;
}> = (props) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
      }}
    >
      <div style={{ paddingRight: "20px" }}>{props.header}</div>
      <div style={{ width: 0 }}>
        <img
          src="/logo-white.png"
          height={32}
          style={{
            paddingTop: "40px",
            paddingLeft: "8px",
          }}
        />
      </div>
    </div>
  );
};

const IllustrationWrapper = styled.div`
  position: relative;
  margin-left: auto;
  margin-right: auto;
  zindex: -1;
`;

const BottomContent: React.FC<{
  androidStoreListing: string;
  appStorePpid: string;
}> = (props) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        paddingLeft: "27px",
        alignItems: "center",
      }}
    >
      <AndroidStoreButton listing={props.androidStoreListing} />
      <SizedBox height={8} />
      <AppStoreButton ppid={props.appStorePpid} />
      <SizedBox height={8} />
      <ContentBody>i bezpiecznie oblicz w telefonie</ContentBody>
    </div>
  );
};

const ContentBody = styled.p`
  font-size: 16px;
  font-weight: 500;
  margin: 0px;
`;
